import {
  ALLOWED_HTML_ATTRIBUTES,
  ALLOWED_HTML_TAGS,
} from '@conversed/shared/src/central/constants/html-sanitization.constants';
import DOMPurify from 'dompurify';

class DOMService {
  purify(text: string | Node) {
    const dompurifyConfig = {
      ALLOWED_TAGS: [...ALLOWED_HTML_TAGS],
      ADD_ATTR: ['target', 'src'],
      ALLOWED_ATTR: [...ALLOWED_HTML_ATTRIBUTES],
    };

    DOMPurify.addHook('afterSanitizeAttributes', (node) => {
      // set all elements owning target to target=_blank
      // TODO: Add hook for _parent if the page is in the same webpage, _blank otherwise
      if ('target' in node && node instanceof HTMLElement) {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener');
      }
    });

    const purifiedText = DOMPurify.sanitize(text, dompurifyConfig);
    return purifiedText;
  }
}

export default new DOMService();
